import { withInstall } from "../utils/index.mjs";
import _DropdownMenu from "./DropdownMenu.mjs";
const DropdownMenu = withInstall(_DropdownMenu);
var stdin_default = DropdownMenu;
import { dropdownMenuProps } from "./DropdownMenu.mjs";
export {
  DropdownMenu,
  stdin_default as default,
  dropdownMenuProps
};
